const bootupTimestamp = Date.now()

export default class SpriteAnimation {
    static getImage({animation, startTimestamp} = {}) {
        if(startTimestamp == undefined) {
            startTimestamp = bootupTimestamp
        }

        let time = Date.now() - startTimestamp

        const duration = animation.frames[animation.frames.length - 1].time
        time %= duration

        const frame = animation.frames.find((frame, index) => {
            if(animation.frames[index + 1] == undefined
            || animation.frames[index + 1].time > time) {
                return true
            }
        })

        if(frame != undefined) {
            return frame.image
        }
    }
}
